"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoshChatClient = void 0;
const FoshChatClient_1 = require("./FoshChatClient");
Object.defineProperty(exports, "FoshChatClient", { enumerable: true, get: function () { return FoshChatClient_1.FoshChatClient; } });
exports.default = FoshChatClient_1.FoshChatClient;
//# sourceMappingURL=index.js.map